import { render, staticRenderFns } from "./IndexNotice.vue?vue&type=template&id=2be2def8&scoped=true&"
import script from "./IndexNotice.vue?vue&type=script&lang=js&"
export * from "./IndexNotice.vue?vue&type=script&lang=js&"
import style0 from "./IndexNotice.vue?vue&type=style&index=0&id=2be2def8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be2def8",
  null
  
)

export default component.exports